export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6202.4ce4727c.jpg";